import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_account_email_verify_clicked',
            props: {
                ...segmentProps,
                user_file_type: '@profile.data.accountIDVStatus',
            },
        },
    },
};
